module.exports = __webpack_public_path__ + "img/switch_model_bg.b2dc84b5.png";